import { Component, DoCheck, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { EmitterService } from '../../services/emitter.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Utility } from '../../shared/utility/utility';

@Component({
  selector: 'app-leftnav-signup',
  templateUrl: './app-leftnav-signup.component.html',
  styleUrls: ['./app-leftnav-signup.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class AppLeftnavSignupComponent implements OnInit,OnDestroy, DoCheck{
  langCode;
  showGoBack:boolean=false;
  stepkey = 'registrationComp.headerStep1';
  destroy$: Subject<boolean> = new Subject<boolean>();
  @Input() step = '';
  isShowScroll = false;
  constructor(
    private router: Router,
    private emitterService: EmitterService,
    private utils:Utility
  ) {

    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
      this.langCode = lang;
    });
    this.emitterService.showLeftCompleteProfile$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if(status){
        this.showStep2();
      }
    });

   }
 
 ngDoCheck(){
  this.isShowScroll = window.location.href.includes("register") ? false : true;
 }
  ngOnInit() {
  }

  closeNavBar(){
    localStorage.removeItem('isFromDeposit');
    const ww = document.body.clientWidth;
    localStorage.removeItem('showRegisterPage');
    if(this.step==='step1'){
      this.showGoBack=true;
    }else{
      this.utils.disablescrollOnRegistrationPageOpend();
    }
    if(location.href.includes('page=step2') && this.step==='step2' &&  ww > 992 ){
      this.emitterService.broadcastRouteChange(false);
      this.emitterService.broadCastToggleNavPanel(false);
      this.emitterService.broadCastMyAccountPage(true);
    }else if(location.href.includes('page=step2') && this.step==='step2' &&  ww <= 992){
      this.emitterService.broadcastRouteChange(false);
      this.router.navigate([this.langCode+"/myaccount"])
    }else if(this.step==='step2'){
      this.emitterService.broadcastRouteChange(false);
      if(!location.href.includes('/myaccount') || ww > 992){
        this.router.navigate([this.langCode]);
      }
      
    }

  }

  showStep2(){
    this.step='step2';
    this.stepkey = 'registrationComp.headerStep2';
  }

  continueReg(){
    this.showGoBack=false;
    this.step='step1'
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
